module.exports = __webpack_public_path__ + "img/swamp.15748e31.jpg";